import type { JSX } from "react";
const STATES = { active: ["●", "进行中"], pending: ["○", "待办"], done: ["✓", "已完成"], withdrawn: ["○", "撤下"] } as const;
export function StatusMark(p: { state: keyof typeof STATES; label?: string; className?: string }): JSX.Element {
  const [mark, label] = STATES[p.state];
  return <span className={`qy-status-mark qy-status-mark--${p.state} ${p.className ?? ""}`}><span aria-hidden="true">{mark}</span>{p.label ?? label}</span>;
}
